import React from "react";

import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";

import { useSelector } from "react-redux";

import { Box, Typography } from "@material-ui/core";
import SectionTicketsTableHading from "./SectionTicketsTableHeading";
import SectionTicketTableItem from "./SectionTicketsTableItem";

const SectionTicketsTable = () => {
  const { sectionTickets } = useSelector(({ events }) => events);

  return (
    <div className="Cmt-table-responsive">
      {sectionTickets && sectionTickets.length === 0 ? (
        <Box
          display={"flex"}
          justifyContent={"center"}
          paddingTop={"30px"}
          paddingBottom={"20px"}
        >
          <Typography variant="h3">موردی برای نمایش وجود ندارد</Typography>
        </Box>
      ) : (
        <Table>
          <TableHead>
            <SectionTicketsTableHading />
          </TableHead>
          <TableBody>
            {sectionTickets.map((item) => (
              <SectionTicketTableItem
                row={item}
                key={item._id}
              />
            ))}
          </TableBody>
        </Table>
      )}
    </div>
  );
};

export default SectionTicketsTable;



